import { BASE_URL } from 'main/routes';
import { home_HomeUrl } from 'main/routes/urls/RouteUrls';

const MSAL_AUTHENTICATION_RETRY_KEY = 'msal-authentication-retry';

export const hasRetriedMsalAuthentication = (): boolean =>
	sessionStorage.getItem(MSAL_AUTHENTICATION_RETRY_KEY) !== null;

export const retryMsalAuthentication = (): void => {
	sessionStorage.setItem(MSAL_AUTHENTICATION_RETRY_KEY, 'true');
	window.location.assign(new URL(`.${home_HomeUrl}`, BASE_URL).href);
};

export const clearMsalAuthenticationRetry = (): void => {
	sessionStorage.removeItem(MSAL_AUTHENTICATION_RETRY_KEY);
};
